import React from 'react';
// components
import ItemHeader from './ItemHeader';
import ItemButtonList from './ItemButtonList';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const TextCard = ({
    el,
    itemsIdx,
    onChangeTxt,
    changeBtnList,
    outputsEl,
    callBackhandleItem,
    maxLengthValue,
    hasItem,
}) => {
    let changedValue = el.description
        ? el.description.substring(0, maxLengthValue)
        : '';

    // maxLength keyup
    const checkMaxLength = (e) => {
        const valueLength = e.target.value.length;
        if (valueLength > maxLengthValue) {
            changedValue = e.target.value.substr(0, maxLengthValue);
        }
    };

    return (
        <div className="item-cont">
            <ItemHeader
                itemsIdx={itemsIdx}
                callBackhandleItem={callBackhandleItem}
                hasItem={hasItem}
            />
            <div className="item txt">
                <div className="item-inp-cont">
                    {/* <textarea
                        rows="2"
                        placeholder="텍스트를 입력해주세요."
                        spellCheck="false"
                        className="description"
                        value={changedValue}
                        onChange={onChangeTxt}
                        onKeyUp={checkMaxLength}
                        onBlur={checkMaxLength}
                        data-idx={itemsIdx}
                    ></textarea> */}
                    <TextareaAutosize
                        rowsMin={2}
                        rowsMax={15}
                        placeholder="텍스트를 입력해주세요."
                        spellCheck="false"
                        className="description"
                        value={changedValue}
                        onChange={onChangeTxt}
                        onKeyUp={checkMaxLength}
                        onBlur={checkMaxLength}
                        data-idx={itemsIdx}
                    />
                    <span>
                        <span>{changedValue.length}</span>/{maxLengthValue}
                    </span>
                    ${!changedValue.length && <i>*</i>}
                </div>
                <ItemButtonList
                    outputsEl={outputsEl}
                    el={el}
                    index={itemsIdx}
                    changeBtnList={changeBtnList}
                />
            </div>
        </div>
    );
};

export default TextCard;
